import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./ServicesListing.css";
import { useNavigate } from "react-router-dom";

const ServicesListing = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "Adoption",
      icon: 'assets/imgs/services_icon/adoption.png',
      link: "/Adoption",
      description: "Find your perfect companion through our adoption services. We connect loving families with pets in need of a forever home, ensuring every match is based on compatibility and care.",
      details: "Our adoption process includes thorough screening, home visits, and ongoing support to ensure a successful transition for both pets and their new families. Join us in giving deserving animals a second chance at happiness."
    },
    {
      title: "Trainers",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/trainers.png`,
      link: "/trainers",
      description: "Professional pet training services to help your furry friend become a well-behaved and happy companion. Our certified trainers use positive reinforcement techniques.",
      details: "From basic obedience to advanced behavioral training, we offer customized programs tailored to your pet's unique needs and your lifestyle goals."
    },
    {
      title: "Fostering & Pet-sitters",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/fostering.png`,
      link: "/fostering-pet-sitters",
      description: "Temporary care solutions for your pets when you're away. Our trusted foster and pet-sitting services ensure your pet receives love and attention in a safe environment.",
      details: "Whether you need daily visits or extended care, our verified caregivers provide personalized attention, regular updates, and peace of mind for you and your pet."
    },
    {
      title: "Groomers",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/groomers.png`,
      link: "/groomers",
      description: "Keep your pet looking and feeling their best with our professional grooming services. From baths and haircuts to nail trimming and styling, we cover all your pet's grooming needs.",
      details: "Our experienced groomers use pet-friendly products and gentle techniques to ensure a stress-free experience for your furry friend."
    },
    {
      title: "Veterinary Services",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/vet.png`,
      link: "/veterinary-services",
      description: "Comprehensive veterinary care for your beloved pets. Our network of qualified veterinarians provides everything from routine check-ups to emergency medical services.",
      details: "We prioritize your pet's health and wellbeing with compassionate care, modern facilities, and transparent communication with pet owners."
    },
    {
      title: "Walkers",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/walkers.png`,
      link: "/walkers",
      description: "Regular exercise and outdoor adventures for your dog with our trusted pet walking services. Perfect for busy pet parents who want to ensure their dogs get the activity they need.",
      details: "Our verified dog walkers provide safe, enjoyable walks tailored to your dog's energy level and preferences, with real-time tracking and updates."
    },
    {
      title: "Pet Food & Accessories",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/pet-food.png`,
      link: "/pet-food-accessories",
      description: "Quality nutrition and stylish accessories for your pets. We offer a curated selection of premium pet food, treats, toys, and accessories to keep your pet healthy and happy.",
      details: "From specialized diets to fun toys, our products are carefully chosen to meet the highest standards of quality and safety for your beloved companions."
    },
    {
      title: "Pet Events",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/events.png`,
      link: "/pet-events",
      description: "Join our vibrant community at exciting pet events and activities. From meetups and workshops to adoption drives and pet-friendly festivals, there's always something fun happening.",
      details: "Connect with fellow pet lovers, learn from experts, and create wonderful memories with your pet at our regularly organized events."
    },
    {
      title: "Pet Registration",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/registration.png`,
      link: "/PetRegistration",
      description: "Official pet registration services to ensure your pet is properly identified and protected. We help you navigate the registration process with ease.",
      details: "Registering your pet provides important legal protection and helps reunite lost pets with their families. Our streamlined process makes it simple and hassle-free."
    },
    {
      title: "Community Q&A Forum",
      icon: `${process.env.PUBLIC_URL}/assets/imgs/services_icon/community.png`,
      link: "/community-forum",
      description: "Connect with a thriving community of pet owners and experts. Ask questions, share experiences, and get advice on all things pet-related in our interactive forum.",
      details: "Whether you're a first-time pet parent or a seasoned owner, our community is here to support you with reliable information and friendly connections."
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-section pb-0">
        <div className="container">
          
          <div className="text-center service-header">
            <h1 className="service-heading">Services</h1>
            <h4 className="service-subheading">
              Everything Pawzible Is Here
            </h4>
          </div>

          <div className="row justify-content-center g-4">
            {services.map((service, index) => (
              <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6" key={index}>
                <div
                  className="service-card-sl text-center"
                  onClick={() => navigate(service.link)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="service-icon">
                    <img
                      src={service.icon}
                      alt={service.title}
                      className="service-icon-img"
                    />
                  </div>

                  <h6>{service.title}</h6>
                </div>
              </div>
            ))}
          </div>

          <div className="pet-image-wrapper">
            <img
               src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
              alt="Pets"
              className="pet-image"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesListing;
